<template lang="html">
    <div id="account">
        <header>
            Account Settings
            <router-link class="cancel" to="/">
                <x-icon class="icon" />
            </router-link>
        </header>
        <ul>
            <li>
                <router-link :to="{ name: 'personal' }">
                    Personal Details
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li v-if="user.type == 'pro'">
                <router-link :to="{ name: 'validation' }">
                    Validation Code
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li v-if="user.type == 'pro'">
                <router-link :to="{ name: 'diaryurl' }">
                    Diary URL
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li v-if="user.type == 'pro'">
                <router-link :to="{ name: 'club' }">
                    Venue Details
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li>
                <router-link :to="{ name: 'password' }">
                    Password
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li v-if="user.type == 'player'">
                <router-link :to="{ name: 'subscription' }">
                    Payment details
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <li>
                <router-link :to="{ name: 'privacy' }">
                    Privacy Settings
                    <chevron-right-icon class="icon"></chevron-right-icon>
                </router-link>
            </li>

            <!-- <li>
        <router-link :to="{name: 'security'}">
          Security
          <chevron-right-icon class="icon"></chevron-right-icon>
        </router-link>
      </li> -->

            <li>
                <a
                    target="_blank"
                    href="https://lessonpro.co.uk/support/"
                    @click.prevent="openExternalTab('https://lessonpro.co.uk/support')"
                >
                    Support
                    <img class="diag" src="@/assets/arrow-diaganol.svg" />
                </a>
            </li>

            <li>
                <a
                    target="_blank"
                    @click.prevent="openExternalTab('https://lessonpro.co.uk/terms')"
                    href="https://lessonpro.co.uk/terms/"
                >
                    Terms
                    <img class="diag" src="@/assets/arrow-diaganol.svg" />
                </a>
            </li>

            <li class="nb">
                <router-link class="button red" :to="{ name: 'Logout' }"> Log out </router-link>
            </li>

            <li class="nb app-info app-info-version" v-if="version" @click="++showDevInfo">
                v{{ version }}
            </li>
            <li v-if="env == 'development' || showDevInfo > 10" class="nb app-info">
                <div>OS: {{ osName }}</div>
                <div>OS version: {{ osVersion }}</div>
                <div v-for="(val, key) in devInfo" :key="key">{{ key }}: {{ val }}</div>
                <div>Image URL example: {{ imageURL("test.png") }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
import { ChevronRightIcon, XIcon } from "vue-feather-icons";
import { osName, osVersion, deviceDetect } from "mobile-device-detect";

export default {
    components: { ChevronRightIcon, XIcon },
    mixins: [imageURL],
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
            version: process.env.VUE_APP_VERSION,
            env: process.env.NODE_ENV,
            devInfo: {
                NODE_ENV: process.env.NODE_ENV,
                BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
                GIT_COMMIT: process.env.VUE_APP_GIT_COMMIT || "unknown",
                STRIPE_KEY_PART: process.env.VUE_APP_STRIPE_KEY
                    ? process.env.VUE_APP_STRIPE_KEY.length > 12
                        ? process.env.VUE_APP_STRIPE_KEY.slice(0, 8) +
                          "..." +
                          process.env.VUE_APP_STRIPE_KEY.slice(-4)
                        : process.env.VUE_APP_STRIPE_KEY
                    : "????",
            },
            showDevInfo: 0,
            osName: osName,
            osVersion: osVersion,
            deviceDetect: deviceDetect(),
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        openExternalTab(url) {
            this.oWebViewInterface.emit("openExternalTab", url);
        },
    },
};
</script>

<style lang="css" scoped>
.button {
    padding: 15px 20px !important;
    font-size: 16px !important;
    padding: 17px !important;
}
.diag {
    float: right;
    margin-top: 5px;
    margin-right: 8px;
}
.icon {
    right: -2px !important;
}
.app-info {
    margin-bottom: 20px;
    text-align: center;
    color: #999;
}
.app-info-version {
    margin-top: 20px;
}
</style>
